import { useEffect } from "react";

const SITE_URL = "https://www.facebookindia.in";

const upsertSchema = (schema) => {
  let el = document.head.querySelector("script#seo-schema");
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = "seo-schema";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(schema);
};

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (!el) return;
  if (value) el.setAttribute(attr, value);
  else el.removeAttribute(attr);
};

const upsertMeta = (property, content, attr = "property") => {
  let el = document.head.querySelector(`meta[${attr}="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, property);
    document.head.appendChild(el);
  }
  if (content) el.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  if (href) el.setAttribute("href", href);
};

const Seo = ({ title, description, path = "", image, schema, children }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | AIO India` : "AIO India — Free Online Classified Marketplace";

    document.title = fullTitle;
    setMeta("meta[name='description']", "content", description || "");
    setMeta("meta[name='robots']", "content", "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1");

    const canonical = path ? `${SITE_URL}${path}` : SITE_URL;
    upsertLink("canonical", canonical);

    const ogImage = image || `${SITE_URL}/logo512.png`;

    upsertMeta("og:title", fullTitle);
    upsertMeta("og:description", description || "");
    upsertMeta("og:url", canonical);
    upsertMeta("og:image", ogImage);
    upsertMeta("og:site_name", "AIO India");
    upsertMeta("og:type", "website");

    upsertMeta("twitter:title", fullTitle, "name");
    upsertMeta("twitter:description", description || "", "name");
    upsertMeta("twitter:image", ogImage, "name");
    upsertMeta("twitter:card", "summary_large_image", "name");

    upsertSchema(schema || {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: fullTitle,
      description: description || "",
      url: canonical,
      inLanguage: "en",
    });

    document.body.scrollTo(0, 0);
  }, [title, description, path, image, schema]);

  return children || null;
};

export default Seo;